(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-message"]) return;
  try {
    

const banner = document.querySelector('.banner-message')

if (banner && document.cookie.indexOf('hide_banner=true') < 0) {
  document.body.classList.add('show--banner')

  banner.addEventListener('click', function(e) {
    e.preventDefault()
    document.body.classList.remove('show--banner')

    document.cookie = "hide_banner=true; path=/";
  })
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-section"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function () {
    var videos = document.querySelectorAll('.homepage-video__desktop, .homepage-video__mobile');

    videos.forEach(function (video) {
      video.muted = true;
      video.playsInline = true;

      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {
          var retry = function () {
            video.play();
            document.removeEventListener('touchstart', retry);
            document.removeEventListener('click', retry);
          };
          document.addEventListener('touchstart', retry, { once: true });
          document.addEventListener('click', retry, { once: true });
        });
      }
    });
  });


  } catch(e) { console.error(e); }
})();
})();
